import PromoShow from "./Items/PromoShow";
import PromoTasks from "./Items/PromoTasks";
import PromoCreate from "./Items/PromoCreate";
import PromoBlockchainInfo from "../../../components/PromoBlockchainInfo/PromoBlockchainInfo";
import {useEffect, useState} from "react";
import Tasks from "../../../components/PromoForm/items/Tasks";
import {ArrowBigUpDash, LucideBanknote, TicketCheckIcon} from "lucide-react";
import api from "../../../api/promosApi";
import paymentApi from "../../../api/paymentApi";
import {message} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {DeleteOutlined} from "@ant-design/icons";
import {setPromoField} from "../../../store/slices/promoFormSlice";
import {Bitcoin, Gem, Layers} from "lucide-react";
import promosApi from "../../../api/promosApi";
export default function PromoDrawLayer({create}) {
    const [isTask, setISTask] = useState(false);
    const [isCreate, setIsCreate] = useState(create)
    const [paid,setPaid] = useState({})
    const promoForm = useSelector((state) => state.promoForm);
    const dispatch = useDispatch()
    const GemIcon = () => <Gem size={14}/>;
    const CoinIcon = () => <Bitcoin size={14}/>;
    const MixIcon = () => <Layers size={14}/>;
    const refreshPage = () => {
        window.location.reload();
    }
    const createPromo = async () => {
        if (create) {
            try {
                console.log(promoForm)

                const response = await api.promosApi.create(promoForm);
                console.log(response.id)

                message.success('promo success created.')
                //  refreshPage()
            } catch (e) {
                console.log(e)
                message.error('error create promo')
            }
        } else {
            message.warning('some wrong')
        }
    }

    const checkIsPaid = async () =>{
        if (!create){
            try {
                const res  = await paymentApi.checkPayment(promoForm.id)
                setPaid(res)
                console.log(res)
            } catch (e){
                console.log(e)
                message.error('при проверки оплаты произошла ощибка')
            }

        }
    }

    const deletePromo = async () => {
        if (promoForm?.id !== 0) {
            try {
                console.log(promoForm?.id)
                const response = await api.promosApi.delete(promoForm?.id)
                refreshPage()
                console.log(response)
                message.success('promo success delete')

            } catch (e) {
                console.log(e)
                message.error('some error when delete promo')
            }
        }
    }
    const startPromo = async ()=>{
        try {
        const res = await promosApi.userPromos.startPromo(promoForm.id)
            console.log(res)
        } catch (e) {
            console.log(e)
        }
    }
    const updatePromo = async () => {
        try {
            if (promoForm.id !== 0) {
                console.log("Original promo:", promoForm);

                // Создаём новый объект без id
                const {id, ...promoData} = promoForm;

                console.log("Promo без id:", promoData);

                const response = await api.promosApi.update(id, promoData);
                console.log("Response:", response);

                message.success("Promo successfully updated");
                refreshPage()
            }
        } catch (e) {
            console.error(e);
            message.error("Some error occurred while updating promo");
        }
    };
    useEffect(()=>{
        checkIsPaid()
    },[])
    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            {/* Контент с тремя секциями */}
            <div className="flex min-h-0 flex-1 flex-row overflow-hidden">
                {/* PromoShow: ширина от контента (~таблица 450px), без лишнего flex-grow */}
                <div className="flex shrink-0 flex-col overflow-y-auto overflow-x-auto border-r border-white/10 p-3">
                    <PromoShow create={create}/>
                    {!create && promoForm.chainId && (
                        <PromoBlockchainInfo promoId={promoForm.id} />
                    )}
                </div>

                {/* PromoTasks: фиксированная ширина как у таблицы — иначе flex растягивал колонку и оставлял пустоту */}
                <div className="flex h-full min-h-0 w-[450px] max-w-full shrink-0 flex-col overflow-hidden border-r border-white/10 p-3">
                    <PromoTasks create={create}/>
                </div>

                {/* Форма: весь оставшийся горизонтальный простор */}
                <div className="min-h-0 min-w-0 flex-1 overflow-y-auto p-3">
                    {/* Инструменты PromoCreate */}
                    <div className="mb-3 flex flex-row flex-wrap items-center gap-3 rounded-xl border border-white/10 bg-white/[0.04] p-2.5 backdrop-blur-xl">
                        {/* Confirm */}
                        {
                            isCreate && <button onClick={() => createPromo()}
                                                className="flex w-[100px] items-center justify-center gap-2 rounded-xl border border-emerald-400/40 bg-emerald-500/20 px-3 py-1.5 text-xs font-medium text-emerald-100 transition hover:bg-emerald-500/30"
                            >
                                <span>✅</span>
                                Confirm
                            </button>
                        }
                        {
                            isCreate &&
                            <div className="ml-0 flex flex-wrap items-center gap-2 sm:ml-4">
                                {[
                                    {
                                        label: "Crystals",
                                        value: "onlyCrystals",
                                        active:
                                            "border-purple-400/45 bg-purple-500/20 text-purple-100",
                                        icon: <GemIcon/>
                                    },
                                    {
                                        label: "Crystals and Promo",
                                        value: "crystalsAndCrypto",
                                        active:
                                            "border-sky-400/45 bg-sky-500/20 text-sky-100",
                                        icon: <MixIcon/>
                                    },
                                    {
                                        label: "Crypto",
                                        value: "cryptoOnly",
                                        active:
                                            "border-amber-400/45 bg-amber-500/20 text-amber-100",
                                        icon: <CoinIcon/>
                                    },
                                ].map((type) => (
                                    <button
                                        key={type.value}
                                        onClick={() => dispatch(setPromoField({field: "promoType", value: type.value}))}
                                        className={`flex items-center gap-1 rounded-xl border px-3 py-1 text-sm font-medium transition-colors
                ${promoForm.promoType === type.value ? type.active : "border-white/10 bg-white/[0.06] text-white/65 hover:border-white/18 hover:bg-white/10 hover:text-white/90"}
                `}
                                    >
                                        {type.icon}
                                        {type.label}
                                    </button>
                                ))}
                            </div>

                        }

                        {
                            !isCreate && <div className={'flex flex-row flex-wrap gap-3'}>
                                {
                                    promoForm?.status === 'ACTIVE' ? (
                                        <div className="flex w-[100px] items-center justify-center gap-2 rounded-xl border border-emerald-400/35 bg-emerald-500/20 px-3 py-1.5 text-xs font-medium text-emerald-100">
                                            <TicketCheckIcon />
                                            Live
                                        </div>
                                    ) : paid?.paid ? (
                                        <button
                                            onClick={() => startPromo()}
                                            className="flex w-[120px] items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-teal-400/40 bg-teal-500/20 px-3 py-1.5 text-xs font-medium text-teal-100 transition hover:bg-teal-500/30"
                                        >
                                            <TicketCheckIcon />
                                            Start promo
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="flex w-[160px] cursor-not-allowed items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-rose-400/35 bg-rose-500/20 px-3 py-1.5 text-xs font-medium text-rose-100"
                                        >
                                            <LucideBanknote />
                                            Unpaid fee ${paid?.fee}
                                        </button>
                                    )
                                }





                                <button onClick={() => updatePromo()}
                                        className="flex w-[100px] items-center justify-center gap-2 rounded-xl border border-amber-400/40 bg-amber-500/20 px-3 py-1.5 text-xs font-medium text-amber-100 transition hover:bg-amber-500/30"
                                >
                                    <ArrowBigUpDash/>
                                    Update
                                </button>
                                <button onClick={() => deletePromo()}
                                        className="flex w-[100px] items-center justify-center gap-2 rounded-xl border border-rose-400/40 bg-rose-500/20 px-3 py-1.5 text-xs font-medium text-rose-100 transition hover:bg-rose-500/30"
                                >
                                    <DeleteOutlined/>
                                    Delete
                                </button>
                            </div>
                        }


                    </div>


                    {/* Контент */}
                    {
                        isTask ? <Tasks/> : <PromoCreate create={create}/>
                    }

                </div>
            </div>
        </div>
    );
}
